import React, { Component } from 'react';
import 'semantic-ui-css/semantic.min.css';
import { Container, Row, Col } from 'react-bootstrap'
import Kartu from '../compo/Main'
class Resume extends Component {
    render() {
        return (
            <div>
                <br /><br />
                <Container className="mt-5">
                    <Row xs={12} sm={12}>
                        <Col md={{ span: 8, offset: 2 }} sm={12}>
                            <Kartu />
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}

export default Resume;